import { authHelper } from "@/utils/helpers";
import axios from "axios";

class Api {
  // eslint-disable-next-line class-methods-use-this
  call(requestType, url, data = null) {
    // Axios 0.19's xhr adapter calls url.indexOf(); a URL object throws and
    // query strings like ?status=pending never reach the server.
    const requestUrl = typeof url === "string" ? url : String(url);
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      axios[requestType](requestUrl, data)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          const status = err.response ? err.response.status : null;
          if (status === 401 || status === 503) {
            authHelper.logout();
          }
          if (requestUrl.includes("/import/products")) {
            if (err.response && err.response.data) {
              window.notify({
                message: err.response.data.message,
                type: "danger",
                title: "Error!"
              });
            }
          } else if (status === 422) {
            reject(err);
            return;
          } else {
            console.log(err.response ? err.response.data : err.message);
          }
          reject(err);
        });
    });
  }
}

export default Api;
